import { groupFilters } from 'app/ProviderSearch/utils'
import { ProviderFilterTypes } from 'dataSource/ProviderSearch'
import { LabelAppointmentMapping } from 'app/ProviderSearch/constants'
import { SlotAvailabilityType } from 'app/Bookings/constants'

export const getAvailabilityFilters = (
  providerDetails: Provider
): ProviderFilter[] => {
  const { filters } = providerDetails ?? {}
  const groupedFilters = filters ? groupFilters(filters) : []
  return groupedFilters[ProviderFilterTypes.AVAILABILITY_TYPE]
}

export const getAvailabilityLabels = (
  availabilityFilters: ProviderFilter[]
): SlotAvailabilityType[] => {
  return availabilityFilters.map(
    (availability) => LabelAppointmentMapping[availability.value]
  )
}
